import { render, staticRenderFns } from "./SuggestionList.vue?vue&type=template&id=d054c896&scoped=true"
import script from "./SuggestionList.vue?vue&type=script&lang=js"
export * from "./SuggestionList.vue?vue&type=script&lang=js"
import style0 from "./SuggestionList.vue?vue&type=style&index=0&id=d054c896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d054c896",
  null
  
)

export default component.exports